
import { Component, Vue } from 'vue-property-decorator'
import ScoreModel from './score.mode'

import { BoardCellCard, PanelSeperator } from '@/components'
import ScorePanel from './score-panel/index.vue'
import AlarmRadarPanel from './alarm-radar-panel/index.vue'
import ScoreHistoryPanel from './score-history-panel/index.vue'
import AlarmCountPanel from './alarm-count-panel/index.vue'

@Component({
  components: {
    ScorePanel,
    BoardCellCard,
    PanelSeperator,
    AlarmRadarPanel,
    ScoreHistoryPanel,
    AlarmCountPanel
  }
})
export default class RankView extends Vue {
  state = {
    selectedDevice: undefined as ScoreModel | undefined,
    selectedIndex: -1,
    query: {
      startTime: 0,
      endTime: 0
    }
  }

  get query() {
    const {
      selectedDevice,
      query: { startTime, endTime }
    } = this.state
    if (typeof selectedDevice === 'undefined') return undefined
    const { deviceId } = selectedDevice
    return {
      deviceId,
      startTime,
      endTime
    }
  }

  handleSelect(value?: any) {
    let { startTime, endTime, value: rest } = value
    if (typeof rest === 'undefined') return
    this.state.selectedDevice = rest
    this.state.query = {
      startTime,
      endTime
    }
  }
}
